if (!customElements.get('smile-video-carousel')) {
  customElements.define('smile-video-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.svc__track');
      const cards = [...this.querySelectorAll('[data-video]')];
      const dialog = this.querySelector('dialog');
      const player = dialog.querySelector('video');
      let index = 0;
      let opener;
      const play = (next) => {
        if (!cards.length) return;
        index = (next + cards.length) % cards.length;
        player.pause();
        player.src = cards[index].dataset.video;
        player.setAttribute('aria-label', cards[index].dataset.title);
        dialog.querySelector('h3').textContent = cards[index].dataset.title;
        dialog.querySelector('[data-video-status]').textContent = `Video ${index + 1} of ${cards.length}`;
        player.play().catch(() => {});
      };
      cards.forEach((card, i) => card.addEventListener('click', () => {
        opener = card;
        dialog.showModal();
        play(i);
      }, options));
      this.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
        if (!cards.length) return;
        const direction = Number(button.dataset.scroll);
        const limit = track.scrollWidth - track.clientWidth;
        const atEnd = direction > 0 && track.scrollLeft >= limit - 2;
        const atStart = direction < 0 && track.scrollLeft <= 2;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollTo({left: atEnd ? 0 : atStart ? limit : track.scrollLeft + direction * (cards[0].offsetWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options));
      this.observer = new ResizeObserver(() => {
        this.querySelectorAll('[data-scroll]').forEach(button => { button.hidden = track.scrollWidth <= track.clientWidth + 2; });
      });
      this.observer.observe(track);
      dialog.querySelectorAll('[data-step]').forEach(button => {
        button.hidden = cards.length < 2;
        button.addEventListener('click', () => play(index + Number(button.dataset.step)), options);
      });
      dialog.querySelector('.svc__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target.classList.contains('svc__stage')) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        player.pause();
        player.removeAttribute('src');
        player.load();
        opener?.focus();
      }, options);
    }
    disconnectedCallback() {
      this.querySelector('dialog video')?.pause();
      this.querySelector('dialog')?.close();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
